import React from 'react';
import { isDiwaliOfferActive } from '../utils/offers';

export default function DiwaliOfferBanner() {
  const active = isDiwaliOfferActive();
  if (!active) return null;
  return (
    <div style={{
      width: '100%',
      background: 'linear-gradient(90deg, #ff9933, #ff4d4d)',
      color: '#fff',
      padding: '12px 16px',
      boxSizing: 'border-box',
      textAlign: 'center',
      position: 'relative',
      zIndex: 1
    }}>
      <div style={{fontWeight: 800, letterSpacing: 0.5, fontSize: 16}}>Diwali Special Offer</div>
      <div style={{fontSize: 14, marginTop: 4}}>
        Regular Plan (12–24 Hours): <span style={{textDecoration:'line-through', opacity:0.9}}>₹599</span> <span style={{fontWeight:800}}>₹499</span> • Valid till Oct 31
      </div>
    </div>
  );
}
